import { combineEpics } from 'redux-observable'
import { AcceptInvitationEpic } from './AcceptInvitationEpic.js'
import { DeleteInviteEpic } from './DeleteInviteEpic.js'
import { GetAllInvitesEpic } from './GetAllInvitesEpic.js'
import { GetInviteByIdEpic } from './GetInviteByIdEpic.js'
import { SaveNewOrderCompletedNotificationEpic } from './SaveNewOrderCompletedEpic.js'
import UpdateOrderCompletedNotificationEpic from './UpdateOrderCompletedNotificationEpic.js'
import { RefreshInvitesOnAcceptEpic } from './RefreshInvitesOnAcceptEpic.js'

export const invitationEpics = combineEpics(
  DeleteInviteEpic,
  AcceptInvitationEpic,
  GetAllInvitesEpic,
  GetInviteByIdEpic,
  SaveNewOrderCompletedNotificationEpic,
  UpdateOrderCompletedNotificationEpic,
  RefreshInvitesOnAcceptEpic
)
